module.exports = __webpack_public_path__ + "assets/0cad448f74617f53bceb4acb6e1e97584.jpg";